import { useEffect } from "react";
import { AboutPortrait } from "@/components/site/AboutPortrait";
import aboutImg from "../assets/dr-sully-hero-blend.jpg?format=jpg&quality=76&w=1024";
import { IMAGE_ALT } from "@/content/image-alt";

/**
 * Bare-frame About portrait used inside <iframe> previews on /qa/about.
 * Accepts `?x=<css>&y=<css>` query params to override the site-wide
 * `--about-anchor-x` / `--about-anchor-y` CSS variables so the parent
 * QA page can live-tune the crop anchor without a rebuild.
 */
export default function QAAboutFrame() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const x = params.get("x");
    const y = params.get("y");
    if (x) document.documentElement.style.setProperty("--about-anchor-x", x);
    if (y) document.documentElement.style.setProperty("--about-anchor-y", y);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-[600px]">
        <div className="relative">
          <AboutPortrait
            src={aboutImg}
            alt={IMAGE_ALT.qaAboutFrame}
            priority={false}
          />
          {/* Rule-of-thirds overlay */}
          <div aria-hidden className="pointer-events-none absolute inset-0 z-10">
            <div className="absolute left-0 right-0 top-1/3 border-t border-dashed border-gold/50" />
            <div className="absolute left-0 right-0 top-2/3 border-t border-dashed border-gold/30" />
            <div className="absolute top-0 bottom-0 left-1/3 border-l border-dashed border-gold/30" />
            <div className="absolute top-0 bottom-0 left-2/3 border-l border-dashed border-gold/30" />
          </div>
        </div>
      </div>
    </div>
  );
}
